<template>
  <div class="page-wrapper container-custom d-flex justify-content-center align-items-center">
    <div class="content-wrapper">
      <div class="title text-center" v-if="false"> {{ appointments.title }}</div>
      <div class="brown-background" v-if="false">
        <div class="paragraph "> {{ appointments.paragraph1 }}</div>
        <div class="paragraph "> {{ appointments.paragraph2 }}</div>
      </div>
      <div class="mt-5">
        <div id="GCwidget"></div>
      </div>
      <div v-if="false">
        <div class="input-item">
          <DropDown :label="appointments.dropdownLabel1"/>

        </div>
        <div class="input-item">
          <MainInput :label="appointments.inputLabel" :theme="'solid-white'"/>
        </div>
        <div class="input-item">
          <DropDown :label="appointments.dropdownLabel2"/>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import MainInput from "@/components/Common/Inputs/MainInput.vue";
import DropDown from "@/components/Common/Inputs/DropDown.vue";

export default {
  name: 'BookAppointmentView',
  components: {
    DropDown,
    MainInput
  },
  props: {},
  data() {
    return {
      appointments: {},

    }
  },
  mounted() {
    this.appointments = {
      title: this.$t('book-appointment-online'),
      paragraph1: this.$t('appointments-paragraph-1'),
      paragraph2: this.$t('appointments-paragraph-2'),
      dropdownLabel1: this.$t('choose-hospital'),
      dropdownLabel2: this.$t('choose-specialty'),
      inputLabel: this.$t('patients-age'),
    };

    var srvURL = "https://gammareserve.unihospitalbg.bg:58500";
    var e2 = document.createElement('script');
    e2.id = "cgwscriptldr";
    e2.src = srvURL + "/bundles/gcwldr?hosp=3&part=&phys=&loadbs=1&loadbss=1&loadjqv=1&cs=default&srvhost=" + encodeURIComponent(srvURL);
    e2.type = 'text/javascript';
    document.getElementsByTagName("body")[0].appendChild(e2);
  },

}
</script>

<style lang="scss">
#app {
  #GCwidget {
    background: transparent;
    font-family: $font-regular;

    .btn-primary {
      background: $color-blue-accent;
      color: #fff;
    }

    h3 {
      font-family: $font-bold;
    }

    //Warning for not payed bills
    #gcw_p1_homeinfo, .alert {
      background: $color-light-brown;
      color: $color-dark-brown;
      border: 0;
      .text-info {
        color: $color-dark-brown !important;
      }
    }

    //Patient age field
    #gcw_age_container input {
      width: 100%;
      font-size: 18px;
      background: #fff;
      color: #000;
      border: 0;
      border-radius: 15px;
      padding: 33px;
    }

    //Main buttons - choose cabinets, choose doctor, etc
    #dLabelw, #dLabelp, #dLabelpt, #dLabelet {
      display: flex;
      width: 100%;
      font-size: 18px;
      background: #fff;
      color: #000;
      border: 0;
      border-radius: 15px;
      padding: 20px;
      text-align: left;

      &:focus {
        outline: none;
        box-shadow: none;
      }

      .caret {
        margin-left: auto;
        border: 0;
        width: 20px;
        height: 25px;

        &:after {
          content: '\2193'
        }
      }
    }

    //Dropdown of the button - showing posible doctors, cabinets, etc
    .dropdown-menu {
      width: 100%;
    }

    //Calendar
    #gcw_p1_cal_container {
      .label-warning {
        background: $color-cta-main;
        box-shadow: none;
        a {
          color: #fff;
          box-shadow: none;
        }
      }
      .table > :not(:first-child) {
        border: 1px solid #ccc;
      }
    }

    #slot_list {
      td:has(> .btn-primary) {
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";


.page-wrapper {
  font-family: $font-regular;
  margin: 120px 0 $spacing-5;
  padding: 80px 25px;
  background: $color-grey;
  color: $color-brown;
}

.brown-background {
  background: $color-light-brown;
  border-radius: 20px;
  padding: 20px 20px;
  width: 100%;
  height: 100%;
}

.title {
  font-size: $title-h5;
  margin-bottom: $spacing-5;
}

.paragraph {
  font-size: $title-h5;
  text-align: center;
}

.input-item {
  margin: 20px 0;
}

.content-wrapper {
  width: 100%;
}


@media screen and (min-width: 768px) {
  .page-wrapper {
    padding: 80px 100px;
  }
  .content-wrapper {
    width: 700px;
  }
  .brown-background {
    padding: 20px 50px;
  }
}
</style>